import React, { lazy, Suspense } from 'react';

import LoadingProfileStickerSmallList from 'components/Suspense/LoadingProfileStickerSmallList';

const ResultList = lazy(() => import('components/Nav/SearchNav/ResultList'));

const Popup = ({ isPopup, data }) => {
  return (
    <div className={`search-popup display-none absolute auto-height background-white border-radius-20 box-shadow overflow-hidden ${isPopup && 'activate'}`}>
      <div className="search-results padding-row-12 overflow-y-scroll">
        <Suspense fallback={<LoadingProfileStickerSmallList />}>
          <ResultList data={data.artists}>Artist</ResultList>
          <ResultList data={data.arts}>Art work</ResultList>
        </Suspense>
      </div>
    </div>
  );
};

export default Popup;
